import { Form } from '@anytag/shared-atoms';
import { SignInFormSchema } from '../../SignIn/SignInForm/schema';
import { SignInFormProps } from '../../SignIn/SignInForm/types';
import { Template } from './Template';

export const TikTokEnterPasswordForm = ({ onSubmit, defaultValues = { password: '', email: '' } }: SignInFormProps) => (
  <Form.Provider onSubmit={onSubmit} defaultValues={defaultValues} zodSchema={SignInFormSchema}>
    <Template />
  </Form.Provider>
);
